module.exports = __webpack_public_path__ + "static/media/cover-volumen-1.99ba2550.jpg";